
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 32 23","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"32","height":"23","data-name":"Vector Smart Object","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAXCAQAAADADIVqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAHdElNRQfkBwcLFjBY4n0HAAACFklEQVQ4y52UTWgTcRDF367ERIO20ajVg4g9FJVK8asgEkFFgtpSL0K9SHvxA4QeJCiIeBCtIgWliB5EDyLFCmIVKqKXgBd7aFGqQtQGpBYMbVMUa5q0Pw+bbDYNydLMu/z/83bezuzOjJCNTY6zhQ6SjHO6yO9A/tgOdBaQa0kTpok0q9wFljHJBRJ0O8gt/KWKADPUugu08BVxDBjEzPpM3jDKGP0YdkAdvfSwMS9gyrIafZdUp0HV62PWO6ewTui4mkT2KVMvNakZPZehnNkZxBBtfOMIGYbtLHJYgRfRwB88+ID180uoYpo9+HhPjCHmeOhIW0SAJCEO8xmxDmini3562Z0rYUq3dU9ehXRFPTqoA7rjSLNZJ3VVj7VNcUn7JZ2XT30a04v8W7xEGaIeIQwuAZtt7iZPMXkLtCFWsgMhQkT55KxzCd2kGaCPOKM0Z73VeAjxC2EU9EMN01wmMP+/rqaVsxzCl70/AlJM8KyoA/z8JowM9iqgUlatBzojQ0s1otki9pRm1WmAvihVQsDQBv1QpgQblKGgSNBYbljKIsRPU8PaqUptlz6YeqWjFQu06LVYQ4qGigpo5B9BIW7xrqj33bGIAW5Ys7CcONcWLNBFDH9umLaSJLKg8ItMWSswX88Ed+3+Kw8/90mw3boZuV2hWj2RXxFFXb78Pl3XuFo1UrhQhFjMOTK4WZoOPPmo/1N/jQ3/Lbf9AAAAAElFTkSuQmCC"}})])
          )
        }
      }
    